<template>
  <div
    class="w-full mx-auto gap-8 px-4 md:px-8 lg:px-10 xl:px-0 max-w-screen-sm md:max-w-screen-xl flex pb-20 md:gap-10 lg:gap-28 justify-center flex-col md:flex-row items-center"
  >
    <div class="flex flex-col justify-end flex-1 max-w-[538px]">
      <img :src="imageSrc" :alt="imageAlt" />
    </div>
    <div
      class="flex flex-col justify-center md:justify-start items-center md:items-start gap-5 text-center md:text-left w-full flex-1"
    >
      <h2 class="text-2xl font-semibold text-black">
        {{ title }}
      </h2>
      <h6 class="text-black max-w-96">
        {{ text }}
      </h6>

      <inertia-link :href="buttonLink" class="btn-no-color">
        {{ buttonText }}
      </inertia-link>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      title: "Resources",
      text: "Stay ahead with industry insights, success stories, and in-depth technical documentation.",
      imageSrc: `/storage/images/home/resources_biometric_authentication_id_verification.png`,
      imageAlt: `Biometric Authentication Id Verification`,
      buttonText: `See more`,
      buttonLink: "resources/ebooks",
    };
  },
};
</script>